var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("main-layout", [
    _c(
      "div",
      { staticClass: "container has-text-white" },
      [
        _c("H1", { staticClass: "pageTitle" }, [
          _c("b", [_vm._v("404")]),
          _vm._v(" The page you requested does not exist.")
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "top40 is-size-2 has-text-white" }, [
          _c("b", [_vm._v("Were you trying to use a slink?")])
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "top20 is-size-5 band has-background-darkTurk" },
          [
            _vm._v("Make sure to enter "),
            _c("b", { staticClass: "has-text-yell" }, [_vm._v('"slink.com/"')]),
            _vm._v(" followed by the "),
            _c("b", { staticClass: "has-text-yell" }, [_vm._v("slink")]),
            _vm._v(" into your browser address bar.")
          ]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "top20 has-text-white is-size-4" }, [
          _vm._v("   You are currently on the "),
          _c("b", [_vm._v("Slink")]),
          _vm._v(" website, which is on "),
          _c("b", [_vm._v("site.slink.com")])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "top60" }, [
          _c("img", { attrs: { src: require("@/assets/img/chevronsY.png") } })
        ])
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0c33ad68", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0c33ad68","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/p404.vue
// module id = null
// module chunks = 